import { ACCOUNT_TYPE, CHANGEABLE_ACCOUNT_TYPES } from '~/consts/accountTypes';

import type { AccountType } from '~/services/UsersService';

export function isAccountTypeChangeable(accountType?: AccountType) {
  return Boolean(accountType) && CHANGEABLE_ACCOUNT_TYPES.includes(accountType);
}

// Guest is only listed so a guest account's current value can be displayed; it is never selectable.
export function getAccountTypeOptions(accountType?: AccountType): Array<AccountType> {
  return accountType === ACCOUNT_TYPE.GUEST ? [ACCOUNT_TYPE.GUEST] : CHANGEABLE_ACCOUNT_TYPES;
}
